import { render, staticRenderFns } from "./BonusesChart.vue?vue&type=template&id=2f46a7d0&scoped=true"
import script from "./BonusesChart.vue?vue&type=script&lang=js"
export * from "./BonusesChart.vue?vue&type=script&lang=js"
import style0 from "./BonusesChart.vue?vue&type=style&index=0&id=2f46a7d0&prod&lang=scss"
import style1 from "./BonusesChart.vue?vue&type=style&index=1&id=2f46a7d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f46a7d0",
  null
  
)

export default component.exports